export default "<p>company works!</p>\n"